import { render, staticRenderFns } from "./PwdUpdate.vue?vue&type=template&id=2570b339"
import script from "./PwdUpdate.vue?vue&type=script&lang=js"
export * from "./PwdUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2570b339')) {
      api.createRecord('2570b339', component.options)
    } else {
      api.reload('2570b339', component.options)
    }
    module.hot.accept("./PwdUpdate.vue?vue&type=template&id=2570b339", function () {
      api.rerender('2570b339', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/dialog/PwdUpdate.vue"
export default component.exports